import { AppImage as Image } from "@/shared/ui/AppImage";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { cn } from "@/shared/lib/cn";

type AppStartupLoaderProps = {
  exiting?: boolean;
};

export function AppStartupLoader({ exiting = false }: AppStartupLoaderProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white transition-opacity duration-500 ease-out",
        exiting && "pointer-events-none opacity-0",
      )}
      role="status"
      aria-live="polite"
      aria-label={t.safecheck.startup.loading}
    >
      <div className="flex flex-col items-center gap-8 px-6">
        <div className="startup-logo-pulse">
          <Image
            src="/logo-1.png"
            alt="Safecheck RDC"
            width={280}
            height={74}
            className="h-20 w-auto"
            priority
          />
        </div>

        <div className="flex w-full max-w-xs flex-col items-center gap-3">
          <div className="h-1 w-full overflow-hidden rounded-full bg-[#dce7e5]">
            <div className="startup-progress h-full rounded-full bg-[#a6f21b]" />
          </div>
          <p className="text-sm font-medium tracking-wide text-[#1f363c]">
            {t.safecheck.startup.loading}
          </p>
          <p className="text-center text-xs text-[#5f7479]">{t.safecheck.startup.platform}</p>
        </div>
      </div>
    </div>
  );
}
